import { EventCodes } from '../../../../../App/model/event-codes';

export const MxObjectAttachments = {
	bindings: {
		multiUpload: '=?',
		objectId: '=?',
		objectIds: '=?',
		excludedFileIds: '=?',
		entity: '@',
		ngModel: '=?',
		lazyMode: '=?',
		readOnly: '=?',
		uploadOnly: '@',
		files: '=?',
		getSelectedObjects: '=?',
		enableSelection: '@',
		skipInitialLoad: '=?',
		filesExists: '=?',
		disableSearch: '<',
		disableSort: '<',
		defaultViewMode: '@',
	},
	controller: MxObjectAttachmentsCtrl,
	controllerAs: 'vm',
	require: { mxFormCtrl: '?^mxForm', parentViewController: '?^mxView' },
	template:
		'<mx-attachments ' +
		'multi-upload="vm.multiUpload" ' +
		'files="vm.files" ' +
		'headers="vm.headers" ' +
		'format-url="vm.formatUrl(url)" ' +
		'on-delete="vm.onDelete(file)" ' +
		'on-comment="vm.onComment(file)" ' +
		'on-get-file-url="vm.onGetFileUrl(file)"' +
		'on-upload-canceled="vm.onUploadCanceled(file)"' +
		'on-upload-canceling="vm.onUploadCanceling()"' +
		'on-download-files="vm.onDownloadFiles(files)" ' +
		'read-only="vm.readOnly || vm.mxFormCtrl.readOnly" ' +
		'upload-only="vm.uploadOnly" ' +
		'upload-file="vm.uploadFile(file)" ' +
		'lazy-mode="vm.lazyMode" ' +
		'load-files="vm.loadFiles()" ' +
		'disable-search="vm.disableSearch" ' +
		'disable-sort="vm.disableSort" ' +
		'storage-info="vm.storageInfo" ' +
		'view-mode="{{vm.viewMode}}" ' +
		'ignore-file-limitations="vm.ignoreFileLimitations" ' +
		'allowed-file-types="vm.allowedFileTypes" ' +
		'settings-initialized="vm.settingsInitialized" ' +
		'file-limits-message="vm.fileLimitsMessage" ' +
		'enable-selection="{{vm.enableSelection}}"> ' +
		'</mx-attachments>',
};

MxObjectAttachmentsCtrl.$inject = [
	'mx.shell.NotificationService',
	'mx.internationalization',
	'$q',
	'$scope',
	'mx.sb.Attachment.MxAttachmentService',
	'mx.shell.EventService',
	'mx.shell.AppsService',
];

function MxObjectAttachmentsCtrl(notificationService, i18n, $q, $scope, attachmentService, eventService, appsService) {
	const vm = this;
	let unsubscribeNotification = () => {};
	vm.$onInit = function () {
		vm.inited = false;
		vm.filesExists = true;
		vm.formatUrl = formatUrl;
		vm.onUploadCanceled = onUploadCanceled;
		vm.onUploadCanceling = onUploadCanceling;
		vm.onDelete = onDelete;
		vm.onComment = onComment;
		vm.onDownloadFiles = onDownloadFiles;
		vm.onGetFileUrl = onGetFileUrl;
		vm.loadFiles = loadFiles;
		vm.files = [];
		vm.uploadFile = uploadFile;
		vm.ignoreFileLimitations = false;

		initProviderSettings();

		unsubscribeNotification = eventService.subscribeOnce(EventCodes.ForegroundProcessCreated, (_, process) => {
			if (process.longRunning && vm.files.some((file) => file.id === process.id)) {
				const currentApp = appsService.getCurrentApplicationSync();
				const message = i18n.getFormatted('shell.mx-shell-background-processes.prevent_reload', currentApp.name);
				notificationService.warning(message);
			}
		});

		const view = vm.parentViewController && vm.parentViewController.mxView;
		if (view && (!vm.defaultViewMode || vm.defaultViewMode === mx.SolutionBuilderAgent.AttachmentsViewMode.Default)) {
			vm.viewMode = view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview ? 'list' : 'tiles';
		} else if (vm.defaultViewMode && vm.defaultViewMode !== mx.SolutionBuilderAgent.AttachmentsViewMode.Default) {
			vm.viewMode = vm.defaultViewMode;
		} else {
			vm.viewMode = mx.SolutionBuilderAgent.AttachmentsViewMode.Tiles;
		}

		vm.getSelectedObjects = function () {
			return vm.files
				.filter((file) => file.selected)
				.map((file) => ({
					Id: file.id,
					DisplayString: file.name,
				}));
		};

		vm.waithandler = $q.defer();

		vm.waithandler.promise
			.then(function () {
				if (vm.skipInitialLoad === true) {
					vm.files = [];
					vm.filesExists = false;
					return null;
				} else if (vm.lazyMode === true) {
					return getCount(vm.objectIds).then(function (count) {
						vm.files = [];
						vm.filesExists = count > 0;
					});
				} else {
					return getFiles(vm.objectIds).then(function (files) {
						vm.files = files;
						vm.filesExists = Boolean(files.length);
					});
				}
			})
			.then(() => (vm.inited = true));

		Object.defineProperty(vm, 'bindAttribute', {
			get: function () {
				return vm.ngModel;
			},
		});
	};

	vm.$onDestroy = function () {
		unsubscribeNotification();
	};

	vm.$postLink = function () {
		if ((vm.objectId === undefined || vm.objectId === '') && vm.mxFormCtrl) {
			vm.objectId = vm.mxFormCtrl.objectId;
		}

		if (!vm.objectIds) {
			vm.objectIds = [];
		}

		if (!vm.excludedFileIds) {
			vm.excludedFileIds = [];
		}

		if (vm.objectId !== undefined && vm.objectId !== '') {
			if (vm.objectIds.length === 0) {
				vm.objectIds.push(vm.objectId);
			}
			vm.waithandler.resolve();
		} else {
			vm.waithandler.reject();
		}
	};

	$scope.$watch('vm.files.length', function (numOfFiles) {
		// Because control can be inside container with visibility related to fileExists property we should wait for actual value
		if (vm.inited) {
			vm.filesExists = Boolean(numOfFiles);
		}
	});

	return vm;

	async function loadFiles() {
		return await getFiles(vm.objectIds).then(function (files) {
			vm.files = files;
			vm.filesExists = Boolean(files.length);
		});
	}

	async function uploadFile(file) {
		const attachmentInfo = Object.assign(file, {
			id: mx.components.Utils.guid(),
			objectId: vm.objectId,
			providerId: vm.storageInfo.providerId,
			storageId: vm.storageInfo.id,
			typeId: vm.storageInfo.typeId,
			isPublic: vm.storageInfo.isPublic,
			objectTitle: escapeHtml(vm.parentViewController?.mxView?.displayName),
			bindAttribute: vm.bindAttribute,
		});
		try {
			await attachmentService.uploadFile(attachmentInfo);
		} catch (e) {
			const defaultErrorMessage = i18n.getFormatted('components.mx-attachments.upload_file_error', file.name);
			if (e?.message) {
				console.error(e.message);
				notificationService.error(e.message + '\r\n\r\n' + defaultErrorMessage);
			} else {
				notificationService.error(defaultErrorMessage);
			}
		}
	}

	async function getCount(objectIds) {
		return await attachmentService.getCount({
			objectIds: objectIds,
			entity: vm.entity,
			bindAttribute: vm.bindAttribute,
			excludedFileIds: vm.excludedFileIds,
		});
	}

	async function getFiles(objectIds) {
		return await attachmentService.getFiles({
			objectIds: objectIds,
			bindAttribute: vm.bindAttribute,
			excludedFileIds: vm.excludedFileIds,
		});
	}

	function formatUrl(url) {
		return attachmentService.formatFileUrl(url);
	}

	function onUploadCanceled(file) {
		deleteFile(file);
	}

	function onUploadCanceling() {
		return notificationService.confirm(
			i18n.get('solutionBuilderAgent.common.cancel'),
			i18n.get('solutionBuilderAgent.common.cancelFileConfirm'),
			i18n.get('solutionBuilderAgent.common.ok_btn'),
			i18n.get('solutionBuilderAgent.common.cancel_btn')
		);
	}

	function onDelete(file) {
		notificationService
			.confirm(
				i18n.get('solutionBuilderAgent.common.remove'),
				i18n.get('solutionBuilderAgent.common.deleteFileConfirm'),
				i18n.get('solutionBuilderAgent.common.ok_btn'),
				i18n.get('solutionBuilderAgent.common.cancel_btn')
			)
			.then(function () {
				deleteFile(file);
			});
	}

	function onComment(file) {
		notificationService
			.prompt(
				i18n.get('components.mx-attachments.dialogCommentTitle'),
				i18n.getFormatted('components.mx-attachments.dialogCommentPrompt', file.name),
				i18n.get('components.common.comment'),
				file.comment,
				false,
				i18n.get('solutionBuilderAgent.common.ok_btn'),
				i18n.get('solutionBuilderAgent.common.cancel_btn')
			)
			.then(function (result) {
				attachmentService.comment(file.id, result).then(
					() => {
						file.comment = result;
					},
					function (error) {
						let messages = ['Url: ' + error.config.url];
						messages = messages.join('\n');
						notificationService.error(messages, `${error.statusText} (${error.status})`, true);
					}
				);
			});
	}

	async function onDownloadFiles(files) {
		if (Array.isArray(files) && files.length > 0) {
			try {
				const result = await attachmentService.downloadFiles(files);
				if (!result) {
					const errorMessage = i18n.get('solutionBuilderAgent.errors.no_file_data');
					notificationService.error(errorMessage);
				}
			} catch (error) {
				let messages = ['Url: ' + error.config.url];
				messages = messages.join('\n');
				notificationService.error(messages, `${error.statusText} (${error.status})`, true);
			}
		} else {
			const errorMessage = i18n.get('solutionBuilderAgent.errors.method_not_called');
			notificationService.error(errorMessage);
		}
	}

	function deleteFile(file) {
		attachmentService.deleteFiles([file]).then(function () {
			const index = vm.files.indexOf(file);
			if (index > -1) {
				vm.files.splice(index, 1);
			}
			vm.filesExists = Boolean(vm.files.length);
		});
	}

	async function onGetFileUrl(file) {
		return await attachmentService.getFileUrl(file);
	}

	async function initProviderSettings() {
		vm.storageInfo = await attachmentService.getStorageInfo(vm.entity);
		let originalExtensions = [];
		if (!vm.storageInfo || !vm.storageInfo.fileExtensions || vm.storageInfo.fileExtensions === '') {
			vm.allowedFileTypes = '*';
		} else {
			originalExtensions = vm.storageInfo.fileExtensions.split(',');
			let extensions = originalExtensions.map((item) => {
				if (item === 'image' || item === 'video' || item === 'audio') {
					return item + '/*';
				}
				return item;
			});
			vm.allowedFileTypes = extensions.join(',');
		}

		vm.fileLimitsMessage = getFileLimitsMessage(originalExtensions);
		vm.settingsInitialized = true;
	}

	function getFileLimitsMessage(extensions) {
		if (!vm.storageInfo.fileExtensions && vm.storageInfo.maxFileSize <= 0 && vm.storageInfo.maxFilesPerObject < 0) {
			return null;
		}

		let fileLimitMessages = [];
		if (vm.storageInfo.maxFileSize > 0) {
			let sizeInMb = vm.storageInfo.maxFileSize / (1024 * 1024);
			let message = i18n.getFormatted('components.mx-object-attachments.maxFileSizeLimitMessage', sizeInMb);
			fileLimitMessages.push(message);
		}
		if (vm.storageInfo.maxFilesPerObject >= 0) {
			let message = i18n.getFormatted('components.mx-object-attachments.maxFilesPerObjectLimitMessage', vm.storageInfo.maxFilesPerObject);
			fileLimitMessages.push(message);
		}
		if (vm.allowedFileTypes !== '*') {
			let message = i18n.getFormatted('components.mx-object-attachments.allowedTypesLimitMessage', extensions.join(', '));
			fileLimitMessages.push(message);
		}
		return i18n.getFormatted('components.mx-object-attachments.fileLimitListMessage', fileLimitMessages.join(', '));
	}

	function escapeHtml(unsafe) {
		return unsafe?.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
}
